/* Popup */
let rhOpenModal, rhCloseModal;

document.addEventListener('DOMContentLoaded', () => {
    let scrollbarWidth = window.innerWidth - document.querySelector('html').offsetWidth;

    window.addEventListener('resize', () => {
        scrollbarWidth = window.innerWidth - document.querySelector('html').offsetWidth;
    }, true);

    function rebalancePopup() {
        const settings = {
            speedOpen: 50,
            speedClose: 150,
            activeClass: "is-active",
            visibleClass: "is-visible",
            selectorTarget: "[data-modal-target]",
            selectorTrigger: "[data-modal-trigger]",
            selectorClose: "[data-modal-close]",
        };

        rhOpenModal = function (target) {
            if (!target) return;
            target.classList.add(settings.activeClass);
            document.documentElement.classList.add('popup-opened');
            document.querySelector('html').style.paddingRight = `${scrollbarWidth}px`;
            setTimeout(() => {
                target.classList.add(settings.visibleClass);
            }, settings.speedOpen);
        };

        rhCloseModal = function (target) {
            if (!target) return;
            const closestParent = target.closest(settings.selectorTarget);
            if (!closestParent) return;

            closestParent.classList.remove(settings.visibleClass);
            document.documentElement.classList.remove('popup-opened');
            document.querySelector('html').style.paddingRight = '0px';
            setTimeout(() => {
                closestParent.classList.remove(settings.activeClass);
            }, settings.speedClose);
        };

        const clickHandler = (event) => {
            const toggle = event.target;
            const open = toggle.closest(settings.selectorTrigger);
            const close = toggle.closest(settings.selectorClose);
            const backLink = toggle.closest('.ingredient-single__back-link');

            if (open) {
                const target = document.querySelector(open.dataset.modalTarget);
                rhOpenModal(target);
            }
            if (close) {
                rhCloseModal(close);
            }
            if (backLink) {
                event.preventDefault();
                const popup = document.querySelector(settings.selectorTarget);
                if (popup) rhCloseModal(popup);
            }
            if (open || close || backLink) {
                event.preventDefault();
            }
        };

        const keydownHandler = (event) => {
            if (event.key === "Escape" || event.keyCode === 27) {
                const modals = document.querySelectorAll(settings.selectorTarget);
                modals.forEach((modal) => {
                    if (modal.classList.contains(settings.activeClass)) {
                        rhCloseModal(modal);
                    }
                });
            }
        };

        document.addEventListener("click", clickHandler, false);
        document.addEventListener("keydown", keydownHandler, false);
    }

    rebalancePopup();

    /* Get Ingredient Page HTML */
    const getIngredientPage = async (item) => {
        const href = item.getAttribute('data-href');
        item.classList.add('is-loading');

        try {
            const response = await fetch(href);
            if (!response.ok) {
                console.error(`Failed to fetch content from ${href}: ${response.status}`);
                return;
            }

            const html = await response.text();
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = html;
            const ingredientContent = tempDiv.querySelector('.shopify-section.ingredient-single');
            const popupBody = document.querySelector('#ingredient-popup .single-ingredient-popup__body');

            if (popupBody) popupBody.innerHTML = ingredientContent ? ingredientContent.outerHTML : '<p>Ingredient not found</p>';

            setTimeout(() => {
                const activeFilters = document.querySelectorAll('.ingredients-list__filter.mixitup-control-active');
                const ingredientProducts = document.querySelectorAll('.ingredient-single__wrapper--new .ingredient-single__products .ingredient-single__products-color');

                ingredientProducts.forEach(product => {
					product.classList.remove('is-active');
				});

                activeFilters.forEach((activeFilter) => {
                    ingredientProducts.forEach(product => {
                        if (product.getAttribute('data-product-id') === activeFilter.getAttribute('data-product-id')) {
                            product.classList.add('is-active');
                        }
                    });
                });

                const popupTrigger = document.querySelector('#ingredient-popup');
                rhOpenModal(popupTrigger);
            }, 200);
        } catch (error) {
            console.error(`Error fetching content from ${href}:`, error);
        } finally {
            setTimeout(() => {
                item.classList.remove('is-loading');
            }, 200);
        }
    };
    /* End Get Ingredient Page HTML */


    /* Click Events */
    document.addEventListener('click', (e) => {
        if (!e.target) return;

        /* open popup */
        if (e.target.classList.contains('ingredients-list__item-wrapper') || e.target.closest('.ingredients-list__item-wrapper')) {
            e.preventDefault();
            const item = e.target.classList.contains('ingredients-list__item-wrapper') ? e.target : e.target.closest('.ingredients-list__item-wrapper');
            getIngredientPage(item);
        }

        if (e.target.classList.contains('ingredients-list__item--new') || e.target.closest('.ingredients-list__item--new')) {
            e.preventDefault();
            const item = e.target.classList.contains('ingredients-list__item--new') ? e.target : e.target.closest('.ingredients-list__item--new');
            getIngredientPage(item);
        }
        /* end open popup */

        /* popup accordion */
        const header = e.target.closest('.ingredient-single__accordion-item-header');
        if (!header) return;

        const parentDropdown = header.closest('.ingredient-single__accordion-item');
        const dropdownContent = parentDropdown.querySelector('.ingredient-single__accordion-item-content');
        const isActive = parentDropdown.classList.contains('is-active');

        if (!isActive) {
            parentDropdown.classList.add('is-active');
            dropdownContent.style.height = dropdownContent.scrollHeight + 'px';
        } else {
            parentDropdown.classList.remove('is-active');
            dropdownContent.style.height = 0;
        }
        /* end popup accordion */
    })
    /* End Click Events */

});
/* End Popup */


/* Tooltip */
class Tooltip extends HTMLElement {
  constructor() {
    super();
    this.width = this.getAttribute('width') || 100;
    this.tooltipBody = this.querySelector('.tooltip__body');
    this.tooltipBodyText = this.querySelector('.tooltip__body-text');
    this.tooltipTrigger = this.querySelector('.tooltip__trigger');
    this.controller = new AbortController();
    this.registerEvents();
  }

  openTooltip(e) {
    e.stopPropagation();
    this.tooltipBody.classList.add('_active');

    if (this.tooltipBodyText.offsetWidth > 0) {
        this.width = this.tooltipBodyText.offsetWidth;
    }

    this.tooltipBody.style.width = this.width + 10 + 'px';

    const body = this.tooltipBody.getBoundingClientRect();
    const trigger = this.tooltipTrigger.getBoundingClientRect();
    const bodyHalfOfWidth = body.width / 2;
    const triggerHalfOfWidth = trigger.width / 2;
    const bias = bodyHalfOfWidth-triggerHalfOfWidth;
    const triggerOffsetLeft = trigger.left;
    const triggerOffsetRight = window.innerWidth - trigger.left - trigger.width;

    this.tooltipBody.style.transform = 'translateX(-50%)';
    if(triggerOffsetLeft < bias && triggerOffsetRight < bias) {
        this.tooltipBody.style.width = window.innerWidth - 20 + 'px';
    } else if(triggerOffsetLeft < bias) {
        this.tooltipBody.style.transform = `translateX(-${triggerHalfOfWidth}px)`;
    } else if(triggerOffsetRight < bias) {
        this.tooltipBody.style.transform = `translateX(-${bodyHalfOfWidth*2 - triggerHalfOfWidth}px)`;
    }
  }

  closeTooltip(e) {
    this.tooltipBody.classList.remove('_active');
  }

  registerEvents() {
    this.tooltipTrigger.addEventListener('click', (this.openTooltip).bind(this), { signal: this.controller.signal });
    this.tooltipTrigger.addEventListener('mouseover', (this.openTooltip).bind(this), { signal: this.controller.signal });
    this.tooltipTrigger.addEventListener('mouseout', (this.closeTooltip).bind(this), { signal: this.controller.signal });
    document.addEventListener('click', (this.closeTooltip).bind(this), { signal: this.controller.signal });
  }

  disconnectedCallback() {
    this.controller.abort();
  }
}

document.addEventListener("DOMContentLoaded", function() {
  customElements.define("tooltip-popover", Tooltip);
});
/* End Tooltip */
